import { OffersType } from '../types/SpecialOfferType'

import { httpRequest } from './httpRequest'

export class OffersAPI {

  constructor(private apiBaseUrl: string) { }

  /** Return special offers object found for given special offer ID, or undefined if none found. */
  public async get(specialOfferID: string): Promise<OffersType| undefined> {

    try {

      const result = await httpRequest('GET', `${this.apiBaseUrl}/offers/${specialOfferID}`)

      if (result.status === 200) {

        const offers: OffersType = await result.json()

        return offers ? offers : undefined
      }

    } catch (err) {

      console.warn(err)
    }

    return undefined
  }

}


